/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * setRequiredCounter.js
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
/**
 * @name setRequiredCounter
 * @description 読み込み時に必須項目をカウントする
 * @param {Number} length 必須項目の残り数
 * @param {Array} inputNames input要素のname属性の値を格納する配列
 * @param {Object} remaining 必須項目の残り数を表示する要素
 * @param {Object} formList 入力フォームの要素
 * @param {Object} doui 同意チェックボックスの要素
 * @param {Function} init 初期化関数
 * @param {Function} rq__set__counter 必須項目をカウントする関数
 */
function setRequiredCounter() {
    let index = 0;
    let inputNames = [];
    const remaining = document.querySelector(".remaining .number");
    const formList = document.querySelectorAll(".form_list");
    const doui = document.querySelector(".doui");
    if (formList.length === 0) return;

    window.addEventListener("DOMContentLoaded", () => init());

    //初期化
    const init = () => {
        rq__set__counter();
        remaining.textContent = index;
    }

    //必須項目
    const rq__set__counter = () => {
        //入力フォーム
        formList.forEach((el) => {
            el.querySelectorAll(".rq").forEach((el) => {
                if (el.value === "") index++;
                if (el.type === "radio") inputNames.push(el.name);
            });
        });

        
        //inputNamesの配列が全て同じ値の場合
        if (inputNames != "" && inputNames.every((v) => v === inputNames[0])) {
            console.log(inputNames);
            index++;
            if (document.querySelector(`input[name="${inputNames[0]}"]:checked`)) {
                index--;
            }
        }

        //同意チェックボックス
        doui.querySelector("input").checked === false && index++;
    }
}

export { setRequiredCounter };